import React from 'react';
import type { RouteComponentProps } from '@gatsbyjs/reach-router';
import DHRouter from '~/components/atom/DHRouter';

import UserList from './components/UserList';
import UserDetails from './UserDetails';
import withErrorBoundary from '~/hocs/withErrorBoundary';

type Props = RouteComponentProps;

const Users: React.FCC<Props> = () => (
  <DHRouter>
    <UserList path="/" />
    <UserDetails path="/:userId" />
  </DHRouter>
);

export default withErrorBoundary(Users);
